import { Box, Typography } from "@mui/material";
import { MenusProps } from "../Menus";
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import { useNavigate } from "react-router-dom";

export default function TemplateDashboard({ type, color }: TemplateDashboardProps) {

    const navigate = useNavigate();

    const handleRedirectDashboard = () => {
        const removerAcentos = type.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const stringMin = removerAcentos.toLocaleLowerCase().replace(/\s+/g, '-')
        navigate(`/${stringMin}`)
    }

    return (
        <Box
            p={1}
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={2}
            maxWidth={200}
            border={`2px dashed ${color}`}
            sx={{ cursor: "pointer" }}
            onClick={handleRedirectDashboard}
        >
            <SpaceDashboardOutlinedIcon sx={{ color }} fontSize="large" />

            <Box>
                <Typography {...{ color }} variant="subtitle2">Dashboard</Typography>
                <Typography {...{ color }} fontWeight="bold" variant="subtitle2">{type}</Typography>
            </Box>
        </Box>
    )
}

interface TemplateDashboardProps extends MenusProps {
    color: string
}